module.exports = __webpack_public_path__ + "static/final-tpm-2-76f978887885ed3e3af9af343b03ff03.jpg";